export default __webpack_public_path__ + "21305ce687b4a4aa75941d5d78d6b9a4.ttf";